<template>
  <div class="tw-flex tw-items-center tw-gap-4">
    <button
      v-if="usingNewLayout && shouldRenderSearch"
      class="sf-btn sf-btn-icon"
      data-testid="review-search-icon"
      @click="openSearchDrawer"
    >
      <span class="sf-icon fa fa-search"></span>
    </button>
    <div
      v-if="!usingNewLayout && shouldRenderSearch"
      class="tw-min-w-[120px] xl:tw-min-w-[280px]"
    >
      <OverviewNavigationSearch
        data-testid="review-outer-search"
        @searched-for="handleSearch"
      />
    </div>
    <WorkflowReviewFilter
      v-if="allowReviews"
      :ledger-id="props.ledgerId"
      :workflow-id="props.workflowId"
    />
    <ProgressIndicator
      v-if="itemLength > 0"
      :current-index="effectiveIndex"
      :show-empty="true"
      :total="effectiveLength"
      class="review-scroll-progress tw-whitespace-nowrap"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { isUsingNewLayout } from '@app/adapters/silverfin'
import OverviewNavigationSearch from '@app/application/workflow-overview-navigation/components/overview-navigation-search.vue'
import ProgressIndicator from './progress-indicator.vue'
import WorkflowReviewFilter from './workflow-review-filter.vue'

import { useDrawer } from '@app/shared/pinia/drawer'
import { useWorkflowOverview } from '@app/application/workflow-overview-navigation/store/overview'
import { useWorkflowOverviewSearch } from '@app/application/workflow-overview-navigation/store/search'
import { useWorfklowReviewItems } from '../store/pinia/workflow-review-items'

defineOptions({
  name: 'WorkflowReviewSubnavSecondaryLeft',
})

interface Props {
  allowReviews?: boolean
  ledgerId: number
  showSearch?: boolean
  workflowId: number
}

const props = defineProps<Props>()

const drawerStore = useDrawer()
const itemsStore = useWorfklowReviewItems()
const overviewStore = useWorkflowOverview()
const overviewSearchStore = useWorkflowOverviewSearch()

const { isLeftDrawerOpen } = storeToRefs(drawerStore)
const { currentIndex, itemLength } = storeToRefs(itemsStore)
const { filteredReviewIndeces, hasAnyFilterApplied } =
  storeToRefs(overviewStore)

const effectiveIndex = computed(() => {
  if (hasAnyFilterApplied.value) {
    const remappedIndex = filteredReviewIndeces.value[currentIndex.value]
    return !remappedIndex && remappedIndex !== 0 ? -1 : remappedIndex
  }

  return currentIndex.value
})

const effectiveLength = computed(() => {
  if (hasAnyFilterApplied.value) {
    return Object.keys(filteredReviewIndeces.value).length || 0
  }

  return itemLength.value
})

const usingNewLayout = isUsingNewLayout()

const shouldRenderSearch = computed(() => {
  return props.showSearch && !isLeftDrawerOpen.value
})

function openSearchDrawer() {
  drawerStore.openLeftDrawer()
  overviewSearchStore.openSearch()
}

function handleSearch(value: string | null) {
  if (value) {
    openSearchDrawer()
  }
}
</script>
